import React from 'react';

import { Divider } from '@mui/material';

import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { BankAccountsStatus } from 'enums/BankAccountsStatus';
import ConnectBankAccountSection from 'prequalificationV2/components/LoanPortal/FundingInformation/ConnectBankAccountSection';
import ManualBankEntrySection from 'prequalificationV2/components/LoanPortal/FundingInformation/ManualBankEntrySection';
import styles from 'prequalificationV2/components/LoanPortal/FundingInformation/FundingInformation.module.scss';

const FundingInformation = () => {
  const { variables } = useAppSelector((state) => state.application);
  const { financialAccountAggregationAttemptComplete, bankAccountsStatus } = useAppSelector(
    (state) => state.dashboardPortal,
  );

  const connectBankIsAvailable =
    !financialAccountAggregationAttemptComplete &&
    bankAccountsStatus !== BankAccountsStatus.SecondAttemptManual &&
    bankAccountsStatus !== BankAccountsStatus.ThirdAttemptManual;

  const manualEntryIsAvailable = !variables?.giact_bank_account_verification_attempt_complete;

  return (
    <>
      {connectBankIsAvailable && (
        <>
          <ConnectBankAccountSection />
          {manualEntryIsAvailable && (
            <Divider
              sx={{
                my: 2,
                '&::before, &::after': {
                  borderTopStyle: 'dashed',
                },
              }}
            >
              <div className={styles.dividerText}>or</div>
            </Divider>
          )}
        </>
      )}
      {manualEntryIsAvailable && <ManualBankEntrySection connectBankIsAvailable={connectBankIsAvailable} />}
    </>
  );
};

export default FundingInformation;
